import React from 'react';
import { useAureliaI18n } from '../../../react-hooks/useAureliaI18n';

const Translated = ({ params, field }) => {
    const value = params?.value;
    const options = field?.options ?? {};
    const { t } = useAureliaI18n();

    if (!value) {
        return <></>;
    }

    return <span>{t((options.prefix || '') + value)}</span>;
};

export default Translated;
